import { useEffect, useState } from 'react';
import axios from 'axios';
import { useLanguage } from '@hilma/netina2all';

import { useI18n, useSettings } from '../hooks';
import { Button } from '../components';

const DonationInfo: React.FC = () => {

	const language = useLanguage()
	const settingsCtx = useSettings();
	const homePageText = useI18n(i18n => i18n.homePageText);
	const alts = useI18n(i18n => i18n.alts);
	const [donationInfo, setDonationInfo] = useState<number | null>(null);

	useEffect(() => {
		getDonationInfo()
	}, [])

	const getDonationInfo = async () => {
		const res = await axios.get('/api/purchase/get-donation-info')
		setDonationInfo(res.data.sum)
	}


	return (
		settingsCtx.error ?
			<></> :
			<div id='contain-donation-info'>
				<div id='contain-donation-total'>
					{/* <img className='donation-total-item' src={'/lulav-icons/Untitled.svg'} alt={alts.donatedBg} /> */}
					<div className='donation-total-item'>₪ {donationInfo ? Number(donationInfo).toLocaleString() : 0}</div>
				</div>
				<div className='donation-info-title' >{homePageText.donationInfo.raisedThisYear}</div>

				<div className='donation-info-text'>
					{homePageText.goal}  {settingsCtx.settings ? settingsCtx.settings.donationTarget.toLocaleString() : ''} {homePageText.shekel}
				</div>

				{settingsCtx.settings && Number(donationInfo) > settingsCtx.settings.donationTarget ?
					<div className='donation-info-text'>
						{homePageText.bonusGoal}  {settingsCtx.settings.donationBonusTarget.toLocaleString()} {homePageText.shekel}
					</div>
					: null}

				<div className='contain-buttons'>
					{settingsCtx.showPurchaseButton ?
						<Button to='/purchase' lightThemeColor className="light-green">{homePageText.alsoDonateBtn}</Button>
						: null}
					<Button to='/distribution-stations' style={language === 'he' ? { marginRight: '20px' } : { marginLeft: '20px' }}>{homePageText.distributionStationsBtn}</Button>
				</div>
			</div>
	);
}

export default DonationInfo;